// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"fa7b4cbc","380":"24edcc10","462":"403aece0","826":"b913b1a4"}[chunkId] + ".chunk.js";
};